import React, { Component } from 'react';
import { bool, string, func, oneOfType, number, object } from 'prop-types';

import styles from './LineTextarea.scss';
import ImeEnhancer from '../ImeEnhancer';
const cx = require('classnames/bind').bind(styles);

class LineTextarea extends Component {
  static propTypes = {
    asyncValidating: bool,
    autoSize: bool,
    disabled: bool,
    errorText: oneOfType([bool, string]),
    floatingLabelText: string,
    isFocussed: bool,
    placeholder: string,
    resize: bool,
    rows: number,
    theme: object,
    type: string,
    value: string,
    wordLimit: number,
    onBlur: func,
    onChange: func,
    onInput: func,
  };

  static defaultProps = {
    asyncValidating: false,
    autoSize: false,
    disabled: false,
    floatingLabelText: '',
    isFocussed: false,
    value: '',
    onBlur: () => {},
    onInput: () => {},
    onChange: () => {},
    type: 'text',
    errorText: false,
    rows: 2,
    resize: false,
    wordLimit: null,
    theme: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };
  }

  componentDidMount() {
    if (this.props.isFocussed) {
      this.input.focus();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { isFocussed } = nextProps;

    if (isFocussed === this.props.isFocussed) {
      return;
    }

    if (isFocussed) {
      this.input.focus();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.autoSize && prevProps.value !== this.props.value) {
      // Init this.input origin height
      this.input.style.height = 'auto';
      if (this.input.scrollHeight >= this.input.offsetHeight) {
        this.input.style.height = `${this.input.scrollHeight}px`;
      }
    }
  }

  handleChange = evt => {
    const { wordLimit, onChange } = this.props;

    const { value } = evt.target;

    if ((wordLimit && value.length <= wordLimit) || !wordLimit) {
      this.setState({
        value,
      });

      onChange(value, evt);
    }
  };

  render() {
    const {
      asyncValidating,
      floatingLabelText,
      onBlur,
      rows,
      errorText,
      disabled,
      resize,
      wordLimit,
      placeholder,
      theme,
    } = this.props;

    const { value } = this.state;

    return (
      <div
        className={cx('root', theme.root, {
          error: errorText,
          disabled,
        })}
      >
        <textarea
          className={cx(theme.textarea, {
            dirty: value,
            asyncValidating,
            resize,
          })}
          rows={rows}
          onChange={this.handleChange}
          onBlur={onBlur}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          ref={e => {
            this.input = e;
          }}
        />
        <span className={styles.bar} />
        <label className={theme.label}>{floatingLabelText}</label>

        {wordLimit && (
          <div className={styles.wordLimitContainer}>
            <span>{`${value.length}/${wordLimit}`}</span>
          </div>
        )}
        {errorText && <p className={styles.error}>{errorText}</p>}
      </div>
    );
  }
}

export { LineTextarea };
export default ImeEnhancer(LineTextarea);



// WEBPACK FOOTER //
// ./app/components/fields/LineTextarea/LineTextarea.jsx